import {
  request,
  websiteRequest,
  serviceUploadResume,
  requestrbac,
  KeycloakAPIs,
  SSOService,
  teamService,
  jobRegistration,
  jobAuthRegistration,
  ServiceCandidate,
  ServiceAuthCandidate,
  assessmentRequest,
  requestRegistration,
  requestVcclRegistration,
  tetrisURL,
  atsPreview,
  converter,
  requestSuggestion,
  notificationAuth,
  // requestSuggestion,
} from "./request.js";

// get feedbackform from uuid
export const getFeedbackFormfromUuid = (data) => {
  return request({
    url: `/pan/feedback-link/`,
    method: "get",
    params: {
      uuid: data.uuid,
    },
  });
};
export const rescheduleVccl = (data) => {
  return requestVcclRegistration({
    url: `/api/reschedule-meeting/`,
    method: "put",
    data,
  });
};
export const cancelVccl = (data) => {
  return requestVcclRegistration({
    url: `/api/cancel-meeting/`,
    method: "delete",
    data,
  });
};

export const getVcclData = (data) => {
  return requestVcclRegistration({
    url: `/api/schedule-meeting/`,
    method: "post",
    data,
  });
};
export const getSentHistory = (data) => {
  return request({
    url: `/pan/feedback-link/?interviewID=${data.interviewID}&remainder=${data.remainder}`,
    method: "get",
    data,
  });
};
// send form to panelist
export const panelFeedbackForm = (data) => {
  return request({
    url: `/pan/feedback-link/`,
    method: "post",
    data,
  });
};

// reset password
export const resetPassword = (data) => {
  return KeycloakAPIs({
    url: `/reset-password/?email=${data.email}&password=${data.password}`,
    method: "put",
    data,
  });
};

// get profile details
export const getProfileDetails = (data) => {
  return KeycloakAPIs({
    url: `/verifyemail/?email=${data.email}`,
    method: "get",
    data,
  });
};

// get appilcations
export const getApplications = () => {
  return KeycloakAPIs({
    url: `/applications/`,
    method: "get",
  });
};
// sign Out alldevices
export const signOutAllDevices = () => {
  return KeycloakAPIs({
    url: `/signout/`,
    method: "delete",
  });
};
// sign out
export const signOutDevices = (data) => {
  return KeycloakAPIs({
    url: `/signout/?id=${data.id}`,
    method: "delete",
    data,
  });
};

// get profile info
export const getProfileInfo = (data) => {
  return KeycloakAPIs({
    url: "/update-user/",
    method: "put",
    data,
  });
};

// get device activity
export const getDeviceActivity = () => {
  return KeycloakAPIs({
    url: "/device-activity/",
    method: "get",
  });
};
export const raiseQuery = (data) => {
  return request({
    url: "/common/query/",
    method: "post",
    data,
  });
};
//get required documents data
export const getRequiredDocuments = () => {
  return request({
    url: "bgv/document-license/?popup=1",
    method: "get",
  });
};
//Search Profiles
export const searchProfiles = (data) => {
  return request({
    url: "search/v4/candidates/",
    method: "post",
    data,
  });
};

// /search/savesearch/
export const searchProfilesSave = (data) => {
  return request({
    url: "search/save-search/",
    method: "post",
    data,
  });
};

export const getSavedSearches = (data) => {
  return request({
    url: "search/get-save-search/",
    method: "post",
    data,
  });
};
// /search/savesearch/
export const updatesearchProfiles = (data) => {
  return request({
    url: "search/save-search/",
    method: "put",
    data,
  });
};
// /search/savesearch/

// change the bookmark status
export const bookmarkProfile = (data) => {
  return request({
    url: "search/bookmark-candidate/",
    method: "post",
    data,
  });
};

// Get bookmarked profiles
export const getBookmarkedProfiles = (data) => {
  return request({
    url: `search/bookmark-candidate/?count=${data.count}&page=${data.page}&searchQuery=${data.searchQuery}`,
    method: "get",
  });
};

export const searchProfilesBookMarked = (data) => {
  return request({
    url: "search/save-search/",
    method: "get",
    params: {
      page: data.page,
      count: data.count,
      searchQuery: data.searchQuery,
    },
  });
};

export const deleteSearchProfiles = (data) => {
  return request({
    url: "search/save-search/",
    method: "delete",
    data,
  });
};

//Funnel Graph Api
export const funnelApi = (data) => {
  return request({
    url: `jd/jd_details_graph/`,
    // url: `jd/jd_details_graph/?jobID=L071222A001CU001JD006`,
    method: "get",
    params: data,
  });
};

// Get candidate profile pdf
export const getCandidateSummary = (data) => {
  return request({
    // url: `rep/candidateSummary/?testID=${data.testID}&topicID=${data.topicID}&emailID=${data.emailID}&jobID=${data.jobID}`,
    url: `/rep/candidate-summary/?emailID=${data.emailID}&jobID=${data.jobID}`,
    method: "get",
    responseType: "blob",
  });
};

//  Candidate profileinfo
export const getCandidateProfileInfo = (emails) => {
  return request({
    url: `search/candidate-information/?email=${emails}`,
    method: "get",
  });
};
// Candidate test info
export const getCandidateTestInfo = (data) => {
  return request({
    url: `search/completed-assessment/?emailID=${data}`,
    method: "get",
  });
};
//course details
export const postCourseDetails = (data) => {
  return request({
    url: `search/course-suggestions/`,
    method: "post",
    data,
  });
};

export function tetrisAPI(templateID, headers) {
  return tetrisURL({
    url: "/template?template=" + templateID,
    method: "post",
    headers,
  });
}

export const converterAtsPreview = (data) => {
  return atsPreview({
    url: "screenshot",
    method: "POST",
    responseType: "blob",
    data,
  });
};

export const getResumeTemp = (template, id) => {
  return ServiceCandidate({
    url: "/can/candidate-resume-render/",
    method: "get",
    params: {
      template,
      id,
    },
  });
};

export const htmlToPDF = (data) => {
  return converter({
    method: "post",
    url: "nodehtmltopdf",
    data,
  });
};

// Get LicenseKey
export const getUserData = (data) => {
  return request({
    url: `cus/LicenseGen/`,
    method: "get",
    data,
  });
};
// Post LicenseKey
export const userToLicenseData = (data) => {
  return request({
    url: `cus/userToLicense/`,
    method: "post",
    data,
  });
};

// AccessPanel User Post Api
export const postAccessData = (data) => {
  return requestrbac({
    url: "userToProject/",
    method: "post",
    data,
  });
};

// AccessPanel User Put Api
export const putAccessData = (data) => {
  return requestrbac({
    url: "userToProject/?project=recruitment",
    method: "put",
    data,
  });
};

// AccessPanel APi GET All Roles
export const getAccessData = (data) => {
  return requestrbac({
    url: `userToProject/?project=recruitment&value=${data.user}&licenseKey=${data.licensekey}&searchQuery=${data.searchQuery}`,
    // url:`userToProject/?project=recruitment&value=${data}&licenseKey=L092921A001`,
    method: "get",
  });
};
// AccessPanel APi GET All Roles
export const getUserAccessData = (params) => {
  return requestrbac({
    url: `v2/userToProject/`,
    // url:`userToProject/?project=recruitment&value=${data}&licenseKey=L092921A001`,
    method: "get",
    params,
  });
};
// AccessPanel APi GET Only Recruiters Roles
export const getAccessRecruitersRoles = (data) => {
  return requestrbac({
    url: `users/?project=recruitment&licenseKey=${data}&roleName=Recruiter`,
    // url:`userToProject/?project=recruitment&value=${data}&licenseKey=L092921A001`,
    method: "get",
  });
};

// AccessPanel APi GET
export const getUserAndRolesData = (data) => {
  return requestrbac({
    url: `customUserToProject/?project=recruitment&value=USER&licenseKey=${data}`,
    // url:`userToProject/?project=recruitment&value=${data}&licenseKey=L092921A001`,
    method: "get",
  });
};

// AccessPanel Delete
export const deleteAccessData = (data) => {
  return requestrbac({
    url: `userToProject/?project=recruitment`,
    method: "delete",
    data,
  });
};

// Get Access Component
export const getAccessComponents = () => {
  return requestrbac({
    url: `component/?project=recruitment`,
    method: "get",
  });
};

// AccessPanel Roles APi GET
export const getAccessRoles = (data) => {
  return requestrbac({
    url: `roles/?project=recruitment&role=${data}&licenseKey=L092921A001`,
    method: "get",
  });
};

// AccessPanel Roles APi GET
export const getRolesDetails = (params) => {
  return requestrbac({
    url: `roles/`,
    method: "get",
    params,
  });
};

// Post Roles APi
export const postRoles = (data) => {
  return requestrbac({
    url: `roles/?project=recruitment`,
    method: "post",
    data,
  });
};

// Edit Roles APi
export const putRoles = (data) => {
  return requestrbac({
    url: `roles/`,
    method: "put",
    data,
  });
};

// Delete Roles APi
export const deleteRoles = (data) => {
  return requestrbac({
    url: `roles/`,
    method: "delete",
    data,
  });
};

// download resume api
export const getResume = (data) => {
  return request({
    url: `cus/v2/download-resume/?candidateID=${data.candidateID}`,
    method: "get",
  });
};
export const panelgetResume = (data) => {
  return request({
    url: `cus/v2/download-resume/?candidateID=${data.candidateID}&licenseKey=${data.licenseKey}`,
    method: "get",
  });
};

// download template to add multiple candidates
export const downloadTemplate = () => {
  return request({
    url: `cus/v3/addcandidatexls/`,
    method: "get",
    responseType: "blob",
  });
};
// upload excel to add multiple candidates
export const uploadExcel = (data) => {
  return request({
    url: `cus/v3/addcandidatexls/`,
    method: "post",
    data,
  });
};

// upload excel to add multiple candidates
export const uploadResumeExcel = (data) => {
  return request({
    url: `cus/v3/addcandidatexls/`,
    method: "patch",
    data,
  });
};

export const addCandidateExcel = (data) => {
  return request({
    url: `cus/v3/addcandidatexls/`,
    method: "put",
    data,
  });
};

// ADD CUSTOMER
export const addCustomer = (data) => {
  return request({
    url: `cus/addcust/`,
    method: "post",
    data,
  });
};

// GET HEATMAP DATA
export const getHeatMap = (data) => {
  return request({
    url: "cus/dashboard-heatmap/",
    method: "get",
    params: {
      count: data.count,
      timeline: data.timeline,
      customerID: data.customerID,
    },
  });
};

// Create Task on Dashboard
export const createTask = (data) => {
  return request({
    url: "task/tasks/",
    method: "post",
    data,
  });
};

// Get Task on Dashboard
export const getTask = (data) => {
  return request({
    url: `task/tasks`,
    method: "get",
    params: {
      type: data.type,
      searchQueries: data.searchQueries,
      statusCode: data.statusCode,
      priority: data.priority,
      page: data.page,
      count: data.count,
    },
  });
};

// Get details of a particular task
export const getParticularTask = (data) => {
  return request({
    url: `task/tasks`,
    method: "get",
    params: {
      taskID: data.taskID,
    },
  });
};

// Get Task Status
export const getTaskStatus = () => {
  return request({
    url: `task/task-status/`,
    method: "get",
  });
};

// Edit Task on Dashboard
export const editTasks = (data) => {
  return request({
    url: "task/tasks/",
    method: "put",
    data,
  });
};

// Get Cards on Dashboard
export const getCards = (data) => {
  return request({
    url: "/common/dashboard-cards/",
    method: "get",
    params: {
      userID: data.userID,
    },
  });
};

// SELECTED TO ON-HOLD JD-DETAILS
export const selectedToOnHold = (data) => {
  return request({
    url: "pan/v2/selected_to_onhold/",
    method: "post",
    data,
  });
};
export const getPanelDetails = (data) => {
  return request({
    url: "/pan/v2/jd-details/",
    method: "get",
    params: {
      jobID: data.jobID,
      interviewRoundID: data.interviewRoundID,
    },
  });
};

// SELECTED TO ON-HOLD JD-DETAILS
export const actionOnFinalHold = (data) => {
  return request({
    url: "pan/v2/onholdaction/",
    method: "post",
    data,
  });
};

// DETAILS OF CANDIDATES MOVED TO ON-HOLD FOR OPSHED APPROVAL
export const finalSelectionReview = (data) => {
  return request({
    url: "pan/final-selection-review/",
    method: "post",
    data,
  });
};

// PUT DETAILS OF CANDIDATES FOR OPSHED APPROVAL
export const finalSelectionApproval = (data) => {
  return request({
    url: "pan/final-selection-review/",
    method: "put",
    data,
  });
};

// GET PENDING CANDIDATE DETAILS FOR OPSHED APPROVAL
export const getPendingCandidateDetails = (data) => {
  return request({
    url: `pan/final-selection-review/?jobID=${data.jobID}&email=${data.email}&candidateID=${data.candidateID}`,
    method: "get",
  });
};

export const getCustomer = (data) => {
  const config = {
    url: `cus/addcust/`,
    method: "get",
    params: {
      sortBy: data.sortColumn,
      order: data.sortOrder,
      type: data.type,
      customerID: data.customerID,
      page: data.page,
      count: data.count,
      searchQuery: data.searchQuery,
      dashboard: data.dashboard,
      customerType: data.customerType,
      ...(data.manage ? { manage: true } : {}),
      ...(data.popup ? { addToJD: true } : {}),
    },
  };
  return request(config);
};
// PUT CUSTOMER
export const putCustomer = (data) => {
  return request({
    url: `cus/addcust/`,
    method: "put",
    data,
  });
};
export const checkCandidate = (data) => {
  return request({
    url: `/cus/v2/check-candidate/`,
    method: "get",
    params: {
      email: data.email,
      phoneNumber: data.phoneNumber,
    },
  });
};

// DELETE CUSTOMER
export const deleteCustomer = (data) => {
  return request({
    url: `cus/addcust/`,
    method: "delete",
    data,
  });
};

//ADD CANDIDATE
export const addCandidate = (data) => {
  return request({
    url: `cus/v2/addcand/`,
    method: "post",
    data,
  });
};

//GET CANDIDATE
export const getCandidate = (type, data) => {
  return request({
    url: `cus/v2/addcand/?type=${type}&jobID=${data.jobID}&customerID=${data.customerID}`,
    method: "get",
  });
};

//UPLOAD RESUME OF CANDIDATE
export const uploadExcResume = (data) => {
  return request({
    url: `cus/v2/addcand/`,
    method: "patch",
    data,
  });
};

//
export const uploadExcResumeNew = (data) => {
  return request({
    url: `cus/v2/upload-resume/`,
    method: "post",
    data,
  });
};

export const getTansactionStat = () => {
  return request({
    url: `/jd/transaction-interview-stats/`,
    method: "get",
  });
};
//

//GET CANDIDATE Jd  Redis
export const getCandidateRedis = (data) => {
  return request({
    // url: `cus/v2/jdCandidates/`,
    url: `/cus/jd-candidates/`,
    method: "post",
    data,
  });
};

export const createJob = (data) => {
  return request({
    url: "jd/add_job/",
    method: "post",
    data,
  });
};
export const getVendorPanel = (data) => {
  return request({
    url: "/jd/getTaggedPanelist/",
    method: "get",
    params: {
      jobID: data.jobID,
    },
  });
};

export const getDraftJob = (data) => {
  return request({
    url: "jd/add_job/",
    method: "get",
    params: {
      type: data.type,
      jobID: data.jobID,
    },
  });
};

export const updateDraft = (data) => {
  return request({
    url: "jd/add_job/",
    method: "put",
    data,
  });
};

export const getReviewDocuments = (data) => {
  return request({
    url: `jd/review-documents/`,
    method: "get",
    params: {
      jobID: data.jobID,
      candidateID: data.candidateID,
    },
  });
};
export const postReviewDocuments = (data) => {
  return request({
    url: `jd/review-documents/`,
    method: "post",
    data,
  });
};

//EDIT CANDIDATE
export const putCandidate = (data) => {
  return request({
    url: `cus/v2/addcand/`,
    method: "put",
    data,
  });
};

// DELETE CANDIDATE
export const deleteCandidate = (data) => {
  return request({
    url: `cus/v2/addcand/`,
    method: "delete",
    data,
  });
};

//SELECT AND REJECT CANDIDATE VIA KANBAN
export const notInterestedCandidate = (data) => {
  return request({
    url: `pan/v2/notinterestedaction/`,
    method: "post",
    data,
  });
};

//SELECT AND REJECT CANDIDATE VIA KANBAN
export const actionCandidate = (data) => {
  return request({
    url: `pan/v2/onholdaction/`,
    method: "post",
    data,
  });
};

// GET OPSHEAD FOR FINAL APPROVAL VIA KANBAN AND JD DETAILS
// To-Do: Make licenseKey dynamic
export const getOpsHead = (data) => {
  return requestrbac({
    url: `permissionDetials/?project=recruitment&licenseKey=${data.licenseKey}&permission=GET_ACCEPT_CANDIDATE&searchQuery=${data.searchQuery}`,
    method: "get",
  });
};

// GET VENDORJDS
export const getVendorJd = (params) => {
  return request({
    url: `ven/ven-jd/`,
    method: "get",
    params,
    // params: {
    //   vendorID: "L071222A001VE078"
    // },
  });
};

// delete vendorjd
export const deleteVendorJD = (data) => {
  return request({
    url: `ven/delete-candidates/`,
    method: "delete",
    data,
  });
};

// vendor talent pool
export const getVendorJdTalentPool = (data) => {
  return request({
    url: `/cus/v2/jd-candidates-popup/`,
    method: "post",
    data,
  });
};

// get candidate VENDORJDS
export const getcandidateVendorJd = (data, candidateID) => {
  const config = {
    url: `ven/vendor-candidates/`,
    method: "get",
    params: data,
  };
  if (candidateID) {
    config.params["candidateID"] = candidateID;
  }
  return request(config);
};

//ADD VENDOR
export const addVendor = (data) => {
  return request({
    url: `ven/addven/`,
    method: "post",
    data,
  });
};
export const uploadResume = (data) => {
  return serviceUploadResume({
    url: `/parseResume`,
    method: "post",
    data,
  });
};

//GET VENDOR
export const getVendor = (data) => {
  const config = {
    url: `ven/addven/`,
    method: "get",
    params: {
      searchQuery: data.searchQuery,
      sortBy: data.sortColumn,
      order: data.sortOrder,
      type: data.type,
      vendorID: data.vendorID,
      page: data.page,
      count: data.count,
      customerType: data.customerType,
    },
  };
  return request(config);
};

//PUT VENDOR
export const putVendor = (data) => {
  return request({
    url: `ven/addven/`,
    method: "put",
    data,
  });
};

// push candidate
export const pushCandidates = (data) => {
  return request({
    url: `ven/push-candidates/`,
    method: "put",
    data,
  });
};
export const getAllTaggedRecruiters = (type, jobID) => {
  return request({
    url: `jd/addjob/?type=${type}&jobID=${jobID}`,
    method: "get",
  });
};
// DELETE VENDOR
export const deleteVendor = (data) => {
  return request({
    url: `ven/addven/`,
    method: "delete",
    data,
  });
};

// export vendor excel
export const getVendorExcelSheet = (data) => {
  const config = {
    url: `ven/vendor-report/`,
    method: "get",
    params: {
      jobID: data.jobID,
      customerID: data.customerID,
    },
  };
  return request(config);
};

//ADD JD
export const addJobDesc = (data) => {
  return request({
    url: `jd/addjob/`,
    method: "post",
    data,
  });
};

//GET JD
export const getJobDesc = (data) => {
  const config = {
    url: `jd/add_job/?type=${data.type}`,
    method: "get",
    params: {
      searchQuery: data.searchQuery,
      order: data.order,
      sortBy: data.sortBy,
      customerID: data.customerID,
      status: data.status,
      page: data.page,
      count: data.count,
    },
  };
  return request(config);
};

//GET Ops Head Review JD
export const getReviewJD = (data) => {
  return request({
    url: `jd/get-jd-apporval/`,
    method: "post",
    data,
  });
};

//PUT JD
export const putJobDesc = (data) => {
  return request({
    url: `jd/addjob/`,
    method: "put",
    data,
  });
};

//Patch JD
export const patchJobDesc = (data) => {
  return request({
    url: `jd/status_update/`,
    method: "put",
    data,
  });
};

//DELETE JD
export const deleteJobDesc = (data, method = "delete") => {
  return request({
    url: "jd/add_job/",
    method: method,
    data,
  });
};

//GET JD WITH CUSTOMIZED KANBAN DETAILS
export const getPerticularJobDescription = (type, data, doc) => {
  let docVal = doc ? true : false;
  return request({
    url: `jd/addjob/?type=${type}&jobID=${data}&document=${docVal}`,
    method: "get",
  });
};

//GET CANDIDATES FOR TALENT POOL
export const getTalentPoolCandidate = (type, candidateID, vendor) => {
  const config = {
    url: `cus/v2/addcand/?type=${type}`,
    method: "get",
  };
  if (candidateID) {
    config["params"] = {
      candidateID: candidateID,
      vendor: vendor,
    };
  }
  return request(config);
};

//GET PANELIST FOR SCHEDULE INTERVIEW
export const getPanelist = (payload) => {
  return request({
    url: `jd/v3/getTaggedPanelist`,
    method: "get",
    params: {
      folderID: payload.folderID,
      jobID: payload.jobID,
      searchFolder: payload.searchFolder,
      searchUser: payload.searchUser,
      searchSubFolder: payload.searchSubFolder,
    },
  });
};
export const getSelctedPanelist = (data) => {
  return requestrbac({
    url: `/global-search-users/`,
    method: "post",
    data,
  });
};

//GET CANDIDATES FOR TALENT POOL <Redis></Redis>
export const getTalentPoolCandidateRedis = (data) => {
  return request({
    url: `cus/v3/talent-pool/`,
    method: "post",
    data,
  });
};

//GET CANDIDATES JD's FOR TALENT POOL Popup  <Redis></Redis>
export const getJdTalentPoolCandidateRedis = (data) => {
  return request({
    url: `cus/v2/JdCandidatePopup/`,
    method: "post",
    data,
  });
};

//GET CANDIDATES JD's FOR TALENT POOL
export const getJdTalentPoolCandidate = (type, data) => {
  return request({
    url: `cus/v2/addcand/?type=${type}&customerID=${data.customerID}&jobID=${data.jobID}&popup=${data.popup}`,
    method: "get",
  });
};

// Generate Share Link
export const generateShareLink = (data) => {
  return request({
    url: `cus/v2/externalCandidate/`,
    method: "put",
    data,
  });
};

//Panel
//post panel
export const addPanel = (data) => {
  return request({
    url: `pan/v2/addpan/`,
    method: "post",
    data,
  });
};

// POST SCHEDULE INTERVIEW
export const addScheduleInterview = (data) => {
  return request({
    url: `pan/v2/schedule_interview/`,
    method: "post",
    data,
  });
};
// select to final round
export const movetofinalround = (data) => {
  return request({
    url: `pan/v2/moveToFinal/`,
    method: "post",
    data,
  });
};
//GET SCHEDULE INTERVIEW
export const getScheduledInterview = (data) => {
  return request({
    url: `pan/v2/schedule_interview/?interviewID=${data}`,
    method: "get",
    data,
  });
};

// PUT SCHEDULE INTERVIEW
export const editScheduleInterview = (data) => {
  return request({
    url: `pan/v2/schedule_interview/`,
    method: "put",
    data,
  });
};

//GET Panel
// export const getPanel = (data) => {
//   return request({
//     url: `pan/addpan/`,
//     method: "get",
//     data,
//   });
// };
export const getPanel = (type, panelID) => {
  const config = {
    url: `pan/v2/addpan/?type=${type}`,
    method: "get",
  };
  if (panelID) {
    config["params"] = {
      panelID: panelID,
    };
  }
  return request(config);
};

//GET Panel Pagination
export const getPanelPagination = (data) => {
  return request({
    url: `pan/v3/get-panlist/`,
    method: "post",
    data,
  });
};

// DELETE Panel
export const deletePanel = (data) => {
  return request({
    url: `pan/v2/addpan/`,
    method: "delete",
    data,
  });
};

// put Panel
export const putpanel = (data) => {
  return request({
    url: `pan/v2/addpan/`,
    method: "put",
    data,
  });
};

//GET Panel
export const getPanelCandidate = () => {
  return request({
    url: `pan/v2/schedule_interview/`,
    method: "get",
  });
};

//GET Panel
export const getAllPanelCandidate = (data) => {
  return request({
    url: `pan/panel-get-interviews/`,
    method: "post",
    data,
  });
};

//GRAPH API AND REPORTS

export const densityGraphApi = (reportselected) => {
  return request({
    url: `cus/dashboard-graph/?timeline=${reportselected}`,
    // url: `cus/dashboard-graph/?timeline=daily`,
    // url: `cus/dashboard-graph/?timeline=monthly`,
    method: "get",
    // data,
  });
};

//For Role Distribution
export const roleDistribution = (data) => {
  return request({
    url: `/rep/roles-distribution/`,
    method: "get",
    params: {
      userID: data.userID,
      lead: data.lead,
    },
  });
};

// For License Usage Statistics
export const usageStats = (data) => {
  return request({
    url: `/rep/usage-stats/`,
    method: "get",
    params: {
      userID: data.userID,
      lead: data.lead,
    },
  });
};

// For Third Party Usage
export const thirdPartyUsage = (data) => {
  return request({
    url: `/rep/thrid-party-usage/`,
    method: "get",
    params: {
      userID: data.userID,
      lead: data.lead,
    },
  });
};

//For Recruiter Graph
export const recGraphDash = (data) => {
  return request({
    url: `/rep/recruiter-selection-ratio/`,
    method: "get",
    params: {
      userID: data.userID,
    },
  });
};

// For Customer Graph

export const CustomerGraphDash = (data) => {
  return request({
    url: `/rep/opening-stats/`,
    method: "get",
    params: {
      userID: data.userID,
      lead: data.lead,
    },
  });
};

//For Vendor Graph
export const vendorGraphDash = (data) => {
  return request({
    url: `/rep/vendor-selection-ratio/`,
    method: "get",
    params: {
      userID: data.userID,
    },
  });
};

//Analytics Reports

//Overview
export const overViewAnalytics = (data) => {
  return request({
    url: `/jd/jd-overview/`,
    method: "get",
    params: data,
  });
};

//Vendor Single
export const vendorStatReport = (data) => {
  return request({
    url: `/jd/jd-vendor-stats/`,
    method: "get",
    params: data,
  });
};

//Vendor All
export const vendorStatReportAll = (data) => {
  return request({
    url: `/jd/jd-vendor-analytics/`,
    method: "get",
    params: data,
  });
};

//Recruiter Statistics
export const recriterStatReport = (data) => {
  return request({
    url: `/jd/jd-recruiter-stats/`,
    method: "get",
    params: data,
  });
};

//Recruiter All
export const recriterStatReportAll = (data) => {
  return request({
    url: `/jd/jd-recruiter-analytics/`,
    method: "get",
    params: data,
  });
};

//Panelist Statistics
export const panelistStatReport = (data) => {
  return request({
    url: `/jd/jd-panel-stats-v2/`,
    method: "get",
    params: data,
  });
};

export const getTransactions = (data) => {
  const responseType = data.excel ? "blob" : undefined;
  return request({
    url: "/pan/transactions/",
    method: "post",
    data,
    responseType,
  });
};

//Panelist All
export const panelistStatReportAll = (data) => {
  return request({
    url: `/jd/jd-panel-analytics-v2/`,
    method: "get",
    params: data,
  });
};
//Panelist Statistics
export const asessmentStatReport = (data) => {
  return request({
    url: `/jd/jd-assessment-stats/`,
    method: "get",
    params: data,
  });
};

//POST Feedback
export const savefeedbackform = (data) => {
  return request({
    url: `pan/v2/interview_response/`,
    method: "post",
    data,
  });
};
export const getfeedbackform = (data) => {
  return request({
    url: `pan/v2/interview_response/?interviewID=${data}`,
    method: "get",
    data,
  });
};

// GET CANDIDATE INTERVIEW HISTORY
export const getFeedbackHistory = (params) => {
  return request({
    url: `pan/v2/interview_response/`,
    method: "get",
    params,
  });
};

// GET KANBAN COUNTS OF EACH INTERVIEW ROUND
export const getRoundsCount = (data, jobID) => {
  return request({
    url: `pan/v2/jobkanbanstatus/?customerID=${data}&jobID=${jobID}`,
    method: "get",
  });
};
// put Feedback
export const putfeedback = (data) => {
  return request({
    url: `pan/v2/interview_response/`,
    method: "put",
    data,
  });
};

// get jd talentpool
export const getCustandJob = () => {
  return request({
    url: `jd/custandjd/`,
    method: "get",
  });
};
export const addtojd = (data) => {
  return request({
    // url: `addtojd/?jobIDs=[${data.candidateSelected}]&candidateIDs=[${data.jobSelected}]`,
    url: `jd/v2/addtojd/`,
    method: "post",
    data,
  });
};

export const addToTalentPool = (data) => {
  return request({
    url: `search/add-to-pool/`,
    method: "post",
    data,
  });
};

export const addintprocess = (data) => {
  return request({
    // url: `addtojd/?jobIDs=[${data.candidateSelected}]&candidateIDs=[${data.jobSelected}]`,
    url: `int/addintprocess/`,
    method: "post",
    data,
  });
};

export const putintprocess = (data) => {
  return request({
    // url: `addtojd/?jobIDs=[${data.candidateSelected}]&candidateIDs=[${data.jobSelected}]`,
    url: `int/addintprocess/`,
    method: "put",
    data,
  });
};

export const delteintprocess = (data) => {
  return request({
    // url: `addtojd/?jobIDs=[${data.candidateSelected}]&candidateIDs=[${data.jobSelected}]`,
    url: `int/addintprocess/`,
    method: "delete",
    data,
  });
};

export const addfeedbackform = (data) => {
  return request({
    // url: `addtojd/?jobIDs=[${data.candidateSelected}]&candidateIDs=[${data.jobSelected}]`,
    url: `int/addfeedbackform/`,
    method: "post",
    data,
  });
};
export const updatefeedbackform = (data) => {
  return request({
    // url: `addtojd/?jobIDs=[${data.candidateSelected}]&candidateIDs=[${data.jobSelected}]`,
    url: `int/addfeedbackform/`,
    method: "put",
    data,
  });
};
export const deletefeedbackform = (data) => {
  return request({
    // url: `addtojd/?jobIDs=[${data.candidateSelected}]&candidateIDs=[${data.jobSelected}]`,
    url: `int/addfeedbackform/`,
    method: "delete",
    data,
  });
};
export const getfeedbackforms = (type, feedbackFormID) => {
  const config = {
    url: `int/addfeedbackform/?type=${type}`,
    method: "get",
    params: {
      feedbackFormID: feedbackFormID,
    },
  };
  if (feedbackFormID) {
    config.params["feedbackFormID"] = feedbackFormID;
  }

  return request(config);
};
export const getfeedback = (data) => {
  const config = {
    url: "int/addfeedbackform/",
    method: "get",
    params: {
      type: data.type,
      searchQuery: data.searchQuery,
    },
  };
  return request(config);
};

export const getFeedbackFormSort = (data) => {
  const config = {
    url: "int/addfeedbackform/",
    method: "get",
    params: {
      type: data.type,
      searchQuery: data.searchQuery,
      sortBy: data.sortBy,
      order: data.order,
      page: data.page,
      count: data.count,
      feedbackFormID: data.feedbackFormID,
      selected: data.selected,
    },
  };
  return request(config);
};

export const getintprocess = (data) => {
  const config = {
    url: `int/addintprocess/`,
    method: "get",
  };
  if (data) {
    config["params"] = {
      interviewProcessID: data.interviewProcessID,
      type: data.type,
      searchQuery: data.searchQuery,
      sortBy: data.sortBy,
      order: data.order,
      page: data.page,
      count: data.count,
      selected: data.selected,
    };
  }
  return request(config);
};

export const generatePositionIds = (data) => {
  return request({
    url: `/jd/position-id-gen/`,
    method: "get",
    params: data,
  });
};

export const changePositionIds = (data) => {
  return request({
    url: `/jd/position-id-gen/`,
    method: "put",
    data,
  });
};

export const getPositionIDStatus = (data) => {
  return request({
    url: `/jd/position-status/`,
    method: "get",
    params: data,
  });
};

export const changePositionIDStatus = (data) => {
  return request({
    url: `/jd/position-status/`,
    method: "put",
    data,
  });
};

export const aiJobDescription = (data) => {
  return serviceUploadResume({
    url: `/ai/job-description/`,
    method: "post",
    data,
  });
};

// Job Dashboard Apis

export const getRecruiterData = (data) => {
  return request({
    url: `/jd/job-dashboard/`,
    method: "get",
    params: data,
  });
};

// export excel
export const getRecruiterExcel = (data) => {
  return request({
    // url: `addtojd/?jobIDs=[${data.candidateSelected}]&candidateIDs=[${data.jobSelected}]`,
    url: `cus/v2/recruiterExcel`,
    method: "post",
    data,
  });
};
export const getperticularintprocess = (data) => {
  return request({
    // url: `addtojd/?jobIDs=[${data.candidateSelected}]&candidateIDs=[${data.jobSelected}]`,
    url: `int/addintprocess/?interviewProcessID=${data}`,
    method: "get",
  });
};
//Offer letter post metod
export const addofferletter = (data) => {
  return request({
    url: `hro/offerletterinitialize/`,
    method: "post",
    data,
  });
};
export const putofferletter = (data) => {
  return request({
    url: `hro/offerletterinitialize/`,
    method: "put",
    data,
  });
};
export const uploaddocuments = (data) => {
  return request({
    url: `hro/hrDocuments/`,
    method: "post",
    data,
  });
};
export const getuploaddocuments = (data) => {
  return request({
    url: `hro/hrDocuments/`,
    method: "get",
    data,
  });
};
export const deleteuploaddocuments = (data) => {
  return request({
    url: `hro/hrDocuments/`,
    method: "delete",
    data,
  });
};
//Offer Letter Get method
export const getofferletter = (candidateID) => {
  return request({
    url: `hro/offerletterinitialize/?recCandidateID=${candidateID}`,
    method: "get",
  });
};
export const getstatus = (data) => {
  return request({
    url: "hro/opsheadresponse/",
    method: "post",
    data,
  });
};
export const getofferletterhtml = (data) => {
  return request({
    url: `hro/hrDocuments/?candidateID=${data.candidateID}&template=1`,
    method: "get",
    params: {
      offeredCTC: data.offeredCTC,
    },
  });
};
// on board candidate

export const onboardCandidate = (data) => {
  return request({
    url: "hro/onboard/",
    method: "post",
    data,
  });
};

// GET APPOINTMENT LETTER HTML
export const getAppointLetter = (data) => {
  return request({
    url: `hro/hrDocuments/?candidateID=${data.candidateID}&appointmentTemplate=1`,
    method: "get",
  });
};

// HR Selected Candidates Get method
export const getselectedcand = (data) => {
  const config = {
    url: "hro/selectedcandidates/",
    method: "get",
    params: {
      candidateID: data,
    },
  };
  return request(config);
};

// HR Selected Pagination Candidates Get method
export const getselectedcandPagination = (data) => {
  const config = {
    url: "hro/selectedcandidates/",
    method: "get",
    params: {
      sortBy: data.sortBy,
      order: data.order,
      count: data.count,
      status: data.status,
      searchQuery: data.searchQuery,
      page: data.page,
    },
  };
  return request(config);
};

// offerletter initialize Candidates Get method
export const getOfferInitialize = (data) => {
  const config = {
    url: `hro/offerletterinitialize/`,
    method: "get",
    params: {
      status: data.status,
      recCandidateID: data.recCandidateID,
      actionList: data.actionList,
    },
  };
  return request(config);
};

// offerletter initialize Candidates Get method
export const getOfferInitializePagination = (data) => {
  const config = {
    url: `hro/offer-letter/`,
    method: "get",
    params: {
      sortBy: data.sortBy,
      order: data.order,
      count: data.count,
      status: data.status,
      actionList: data.actionList,
      searchQuery: data.searchQuery,
      page: data.page,
    },
  };
  return request(config);
};

// offerletter initialize Candidates Get method
export const sendForApproval = (data) => {
  return request({
    url: `hro/sendforapproval/`,
    method: "post",
    data,
  });
};

// GET CANDIDATE COUNTS FOR HR DASHBOARD
export const candidateCounts = () => {
  return request({
    url: `hro/HRDashboardCount/`,
    method: "get",
  });
};

// ASSIGN DOCUMENTS TO CANDIDATES IN HR
export const sendDocsToCandidate = (data) => {
  return request({
    url: "hro/sendtocandidate/",
    method: "post",
    data,
  });
};
// REASSIGN DOCUMENTS TO CANDIDATES IN HR
export const ReSendDocsToCandidate = (data) => {
  return request({
    url: "hro/sendtocandidate/",
    method: "put",
    data,
  });
};

// MAKE CANDIDATE NOT INTERESTED
export const setNotInterested = (data) => {
  return request({
    url: "hro/candidate-to-ni/",
    method: "post",
    data,
  });
};
export const getHrNotification = () => {
  return request({
    url: "hro/hr-dashboard-notification/",
    method: "get",
  });
};

export const createUser = (data, header) => {
  return KeycloakAPIs({
    url: `/admin/realms/SimplifyCV/users`,
    method: "post",
    headers: header,
    data,
  });
};

export const forgotPassword = (email) => {
  return KeycloakAPIs({
    url: `forgot-password/?email=${email}`,
    method: "get",
  });
};

// HR Selected Candidates Send Candid
// export const getcandidateID = (candidateID) => {
//   return request({
//     url: `hro/selectedcandidates/?candidateID=${candidateID}`,
//     method: "get",
//   });
// };

//get assessmenttopic
export const getTopic = (data) => {
  return assessmentRequest({
    // url: `lis/TopicOrg/`,
    url: "lis/jd-topic-list/",
    method: "get",
    params: {
      searchQuery: data.searchQuery,
      sortBy: data.sortBy,
      order: data.order,
      type: data.type,
      page: data.page,
      count: data.count,
    },
  });
};

// GET assessmentTest
export const getTest = (data) => {
  const config = {
    url: `lis/jd-test-list/`,
    method: "get",
    params: {
      topicID: data.topicID,
      searchQuery: data.searchQuery,
      sortBy: data.sortBy,
      order: data.order,
      type: data.type,
      page: data.page,
      count: data.count,
    },
  };
  return assessmentRequest(config);
};

export const putTest = (data) => {
  return assessmentRequest({
    url: `lis/TestOrg/`,
    method: "put",
    data,
  });
};
export const updateConfiguration = (data) => {
  return assessmentRequest({
    url: `lis/configureIPTests/`,
    method: "post",
    data,
  });
};
export const postSharePageData = (data) => {
  return assessmentRequest({
    url: `lis/ShareOrg/`,
    method: "post",
    data,
  });
};

export const triggerAssessment = (data) => {
  return request({
    url: `pan/v2/manualassessmenttrigger/`,
    method: "post",
    data,
  });
};

// SSO API

export const userLogin = (data, headers) => {
  return SSOService({
    url: `auth/realms/SimplifyCV/protocol/openid-connect/token`,
    method: "post",
    headers: headers,
    data,
  });
};

export const userLogOut = (data, headers) => {
  return SSOService({
    url: `auth/realms/SimplifyCV/protocol/openid-connect/logout`,
    method: "post",
    headers: headers,
    data,
  });
};

export const getTeamsToken = (params) => {
  return teamService({
    url: `teamstoken/`,
    method: "get",
    params,
  });
};
// Check jd is valid or not
export const validJobRegistration = (jobID) => {
  return jobRegistration({
    url: `cus/v2/externalCandidate/?jobID=${jobID}`,
    method: "get",
  });
};

// Post externalCandidate
export const postExternalCandidate = (data) => {
  return jobRegistration({
    url: `cus/v2/externalCandidate/`,
    method: "post",
    data,
  });
};

export const getTaggedConfig = (testID, configID) => {
  const config = {
    url: `share/taggedconfig/?testID=${testID}`,
    method: "get",
  };
  if (configID) {
    config["params"] = {
      configID: configID,
    };
  }
  return assessmentRequest(config);
};
export const postShareGroup = (data) => {
  return assessmentRequest({
    url: `share/group/`,
    method: "post",
    data,
  });
};
export const putShareGroup = (data) => {
  return assessmentRequest({
    url: `share/group/`,
    method: "put",
    data,
  });
};
export const addConfig = (data) => {
  return assessmentRequest({
    url: `share/v2/config`,
    method: "post",
    data,
  });
};
export const editConfig = (data) => {
  return assessmentRequest({
    url: `share/v2/config`,
    method: "put",
    data,
  });
};
export const getConfig = (configID) => {
  const config = {
    url: `share/v2/config/`,
    method: "get",
  };
  if (configID) {
    config["params"] = {
      configID: configID,
    };
  }

  return assessmentRequest(config);
};
export const getJDProgress = (data) => {
  return ServiceCandidate({
    url: `/can/v2/candidateJDProgress/?candidateID=${data.candidateID}&jobID=${data.jobID}`,
    method: "get",
  });
};

// get configs for pagination
export const getConfigPage = (data) => {
  const config = {
    url: "share/v2/get-all-configs",
    method: "post",
    data,
  };
  return assessmentRequest(config);
};

export const dosanddontslist = () => {
  return assessmentRequest({
    url: `proctoring/codeList`,
    method: "get",
  });
};

export const getEvalList = (data) => {
  return assessmentRequest({
    url: `share/v2/evaluator-admin`,
    method: "post",
    data,
  });
};

// cancel meeting api call
export const cancelmeeting = (data) => {
  return request({
    url: `pan/v2/cancelInterview/`,
    method: "put",
    data,
  });
};

// teams
// global search for scheduling interview
export const getGlobalPanelist = async (data) => {
  return request({
    url: "pan/global-panel-search/",
    method: "post",
    data,
  });
};

// global users search while adding recruiter and panelist
export const getGlobalUsers = async (data) => {
  return requestrbac({
    url: "/global-search-users/",
    method: "post",
    data,
  });
};

// get folder details
export const getFolderDetails = async (data) => {
  return requestrbac({
    url: `/teams`,
    method: "get",
    params: { ...data },
  });
};

// create new folder
export const addFolder = async (data) => {
  return requestrbac({
    url: `/teams`,
    method: "post",
    data,
  });
};

// get users
export const getUsers = async (data) => {
  return requestrbac({
    url: `/taggableUsers`,
    method: "get",
    params: {
      project: data.project,
      licenseKey: data.licenseKey,
      folderID: data.folderID,
      searchQuery: data.searchQuery,
    },
  });
};

//update folder and add user
export const addFolderUser = async (data) => {
  return requestrbac({
    url: "/teams",
    method: "put",
    data,
  });
};

// delete folder and user
export const deleteFolderUser = async (data) => {
  return requestrbac({
    url: "/teams",
    method: "delete",
    data,
  });
};

// get folders for create JD
export const getBrowseFolders = async (data) => {
  return requestrbac({
    url: "/browseFolders",
    method: "get",
    params: {
      searchQuery: data.searchQuery,
      project: data.project,
      licenseKey: data.licenseKey,
      folderID: data.folderID,
      exactRole: data.exactRole,
    },
  });
};

/**
 * Sends a GET request to the server to retrieve dashboard notifications.
 *
 * @param {Object} data - An object containing count and page properties used to paginate the results.
 * @returns {Promise} A Promise object that resolves to the server response.
 */
export const getDashboardNotification = async (data) => {
  return request({
    url: "notification/notification/?project=Recruitment", // API endpoint for retrieving notifications
    method: "get", // HTTP method for the request
    params: {
      count: data.count, // Number of notifications to retrieve per page
      page: data.page, // Page number to retrieve
    },
  });
};

export const putDashboardNotification = async (data) => {
  return request({
    url: "notification/notification", // API endpoint for retrieving notifications
    method: "put", // HTTP method for the request
    data,
  });
};
export const getmarksdetails = async (data) => {
  return request({
    url: `pan/get-assessment-response/?interviewID=${data}`,
    method: "get",
  });
};

//Get expertise for panelist
export const getsearchresexp = (data) => {
  return request({
    url: `location/expertise/?expertise=${data}`,
    method: "get",
  });
};
//Get skills for panelist
export const getsearchresskl = (data) => {
  return request({
    url: `location/skill/?skill=${data}`,
    method: "get",
  });
};
export const getsearchresloc = (data) => {
  return request({
    url: `location/location/?location=${data}`,
    method: "get",
  });
};
//Get keyword
export const getsearchreskey = (data) => {
  return request({
    url: `location/keyword/?keyword=${data}`,
    method: "get",
  });
};

//Post expertise for panelist
export const addsearchresexp = (data) => {
  return request({
    url: `location/expertise`,
    method: "post",
    data,
  });
};
//Post skills for panelist
export const addsearchresskl = async (data) => {
  return request({
    url: `location/skill`,
    method: "post",
    data,
  });
};
export const addsearchresloc = async (data) => {
  return request({
    url: `location/location`,
    method: "post",
    data,
  });
};
export const addsearchreskey = async (data) => {
  return request({
    url: `location/keyword`,
    method: "post",
    data,
  });
};
// Candidates applied for JD
export const allCandidatestoJD = async (data) => {
  return request({
    url: `/jd/candidates-applied-to-job/`,
    method: "post",
    data,
  });
};
//select candidate to JD
export const selectCandidatetoJD = async (data) => {
  return request({
    url: `jd/select-candidates-to-job/`,
    method: "post",
    data,
  });
};
//status of selected candidate to JD
export const candidateStatus = (data) => {
  return request({
    url: `jd/candidate-jobApply-status/?jobID=${data.jobID}&emailID=${data.emailID}`,
    method: "get",
  });
};

// student registration

export const registration = (data) => {
  return requestRegistration({
    url: `cus/v2/addcand/`,
    method: "post",
    data,
  });
};

export const availableSlots = (data) => {
  return requestRegistration({
    url: `cus/v2/available-slots/`,
    method: "post",
    data,
  });
};

export const getPreference = () => {
  return websiteRequest({
    url: `user-preference/`,
    method: "get",
  });
};

export const postPreference = (data) => {
  return websiteRequest({
    url: `user-preference/`,
    method: "post",
    data,
  });
};

//get all forms
export const getForms = () => {
  return request({
    url: `common/forms/`,
    method: "get",
  });
};

//get single form
export const getSingleForm = (params) => {
  return request({
    url: `common/form-config/`,
    method: "get",
    params,
  });
};

//save form
export const saveFields = (data) => {
  return request({
    url: `common/form-config/`,
    method: "put",
    data,
  });
};

// manage new API's
export const getCustomerFields = (data) => {
  return request({
    url: `/common/form-config/`,
    method: "get",
    params: {
      parentID: data.parentID,
    },
  });
};

export const RecSourseGraph = (data) => {
  return request({
    url: `/rep/recruiter-candidates-sourced/`,
    method: "get",
    params: data,
  });
};
export const RecCandExperience = (data) => {
  return request({
    url: `/rep/recruiter-experience-graph/`,
    method: "get",
    params: data,
  });
};

//HeatMap Graph
export const interviewReport = (data) => {
  return request({
    url: `/rep/panel-contribution-chart-v2/`,
    method: "get",
    params: data,
  });
};

export const getRbacDetails = (data) => {
  return requestrbac({
    url: `permissionDetials/`,
    method: "get",
    params: {
      project: data.project,
      licenseKey: data.licenseKey,
      permission: data.roles.join(","),
      searchQuery: data.searchQuery,
    },
  });
};

export const getProfilePic = (name) => {
  return ServiceCandidate({
    url: `/user/static-image/?name=${name}`,
    method: "get",
  });
};

// check if panelist exists already
export const checkPanelExists = (params) => {
  return request({
    url: `/pan/panel-status/`,
    method: "get",
    params,
  });
};

// upload documents api
export const uploadDocumentAPI = (data) => {
  return request({
    url: `/common/file-upload-patch/`,
    method: "patch",
    data,
  });
};

// get user info added by user

export const getUsersDropdown = (params) => {
  return request({
    url: `/cus/addedby-userinfo/`,
    method: "get",
    params,
  });
};

export const getCandidateJobHistory = (params) => {
  return request({
    url: `/cus/candidate-job-history/`,
    method: "get",
    params,
  });
};

export const downloadAnyFile = (data) => {
  return request({
    url: `/cus/v2/download-resume/`,
    method: "get",
    params: {
      path: data,
    },
  });
};

// kanban

export const getRoundDetails = (data) => {
  return request({
    url: `/cus/jd-kanban/`,
    method: "post",
    data,
  });
};

export const getSingleJob = (data) => {
  return request({
    url: `/jd/get-jobs/`,
    method: "post",
    data,
  });
};

export const getJdRecruiters = (data) => {
  return request({
    url: `/jd/jd-recruiter-list/`,
    method: "get",
    params: {
      jobID: data.jobID,
      customerID: data.customerID,
    },
  });
};

export const updateApplyToAll = (data) => {
  return request({
    url: "jd/jd-recruiter-list/",
    method: "post",
    data,
  });
};

//get single form
export const getVendorClients = (params) => {
  return request({
    url: `/ven/get-vendor-clients/`,
    method: "get",
    params,
  });
};

// get candidate VENDORJDS
export const getVendorCandidates = (data) => {
  return request({
    url: `ven/vendor-candidates/`,
    method: "post",
    data,
  });
};

// new reports API starts from here
export const getPanelistInterviewReports = (data) => {
  return request({
    url: `rep/panel-interview-table/`,
    method: "get",
    params: data,
  });
};

export const getPanelistCandidateReports = (data) => {
  return request({
    url: `rep/panel-candidate-feedback-table/`,
    method: "get",
    params: data,
  });
};
export const getPanelistInterviewReportsExcel = (data) => {
  return request({
    url: `rep/panel-interview-table/`,
    method: "get",
    params: data,
    responseType: "blob",
  });
};

export const getCustomerReports = (data) => {
  return request({
    url: `rep/customer-customers-table/`,
    method: "get",
    params: data,
  });
};

export const getCustomerReportsSelection = (data) => {
  return request({
    url: `rep/customer-selection-summary/`,
    method: "get",
    params: data,
  });
};

export const getCustomerReportsExcel = (data) => {
  return request({
    url: `rep/customer-customers-table/`,
    method: "get",
    params: data,
    responseType: "blob",
  });
};

//Source Graph
export const getSourceGraph = (data) => {
  return request({
    url: `/rep/customer-candidates-sourced/`,
    method: "get",
    params: data,
  });
};

//Assessment Graph

export const getAssesGraph = (data) => {
  return request({
    url: `/rep/customer-assessments-taken/`,
    method: "get",
    params: data,
  });
};

export const getCustomerStats = (data) => {
  return request({
    url: `rep/customer-job-statistics-table/`,
    method: "get",
    params: data,
  });
};

export const getVendorReports = (data) => {
  return request({
    url: `rep/vendor-table/`,
    method: "get",
    params: data,
  });
};

export const getVendorReportsExcel = (data) => {
  return request({
    url: `rep/vendor-details-export/`,
    method: "get",
    params: data,
    responseType: "blob",
  });
};

export const getVendorSelectedReports = (data) => {
  return request({
    url: `rep/vendor-selected-table/`,
    method: "get",
    params: data,
  });
};

export const getVendorJobReport = (data) => {
  return request({
    url: `rep/vendor-job-report/`,
    method: "get",
    params: data,
  });
};

export const getRecruiterReports = (data) => {
  return request({
    url: `rep/recruiter-table/`,
    method: "get",
    params: data,
  });
};

export const getRecruiterReportsEcel = (data) => {
  return request({
    url: `rep/recruiter-table/`,
    method: "get",
    params: data,
    responseType: "blob",
  });
};

export const getRecruiterSources = (data) => {
  return request({
    url: `rep/recruiter-sourced-skills/`,
    method: "get",
    params: data,
  });
};

export const getSelectedRecruiter = (data) => {
  return request({
    url: `rep/recruiter-selected-candidates-table/`,
    method: "get",
    params: data,
  });
};

// new reports API ends here

export const getProjectUsers = () => {
  return request({
    url: `common/project-usernames/`,
    method: "get",
  });
};
// to get recruiter list
export const getRecruiters = (data) => {
  return requestrbac({
    url: `permissionDetials/?project=recruitment&licenseKey=${data.licenseKey}&permission=${data.permission}&searchQuery=${data.searchQuery}`,
    method: "get",
  });
};
export const getDashboardInterviews = (data) => {
  return request({
    url: `/rep/dashboard-scheduled-interviews-v2/?count=${data.count}&page=${data.page}&searchQuery=${data.searchQuery}&sortBy=${data.sortBy}&order=${data.order}&type=${data.type}&lead=${data.lead}`,
    method: "get",
  });
};
export const getRecentlySelectedCand = (data) => {
  return request({
    url: `/rep/selected-candidates/?searchQuery=${data.searchQuery}&sortBy=${data.sortBy}&order=${data.order}&lead=${data.lead}`,
    method: "get",
  });
};
export const getSelectedRatio = (data) => {
  return request({
    url: `/rep/selected-ratio/?lead=${data.lead}`,
    method: "get",
    data,
  });
};
export const getLeadStatus = (data) => {
  return request({
    url: `/rep/lead-check/`,
    method: "get",
    data,
  });
};
export const getJobAlerts = (data) => {
  return request({
    url: `/rep/job-state/?lead=${data.lead}`,
    method: "get",
    data,
  });
};
//request documents
export const requestDocuments = (data) => {
  return request({
    url: `/cus/doc-upload-mail/`,
    method: "post",
    data,
  });
};

// Candidate Caching
export const addCacheCandidates = (data) => {
  return request({
    url: `/cus/cache-candidates/`,
    method: "post",
    data,
  });
};

export const getCacheCandidates = () => {
  return request({
    url: `/cus/cache-candidates/`,
    method: "get",
  });
};

export const deleteCacheCandidates = (data) => {
  return request({
    url: `/cus/cache-candidates/`,
    method: "delete",
    data,
  });
};

export const uploadCacheCandidatesFiles = (data) => {
  return request({
    url: `/cus/cache-candidates/`,
    method: "patch",
    data,
  });
};

export const addCandidatestoDB = (data) => {
  return request({
    url: `/cus/cache-candidates/`,
    method: "put",
    data,
  });
};

export const thirdPartyImportCheck = (data) => {
  return request({
    url: `/jd/third-party-candidate-import-check/`,
    method: "post",
    data,
  });
};

export const getRegisterJob = (data) => {
  return jobRegistration({
    url: `/jd/public-job/?jobID=${data}`,
    method: "get",
  });
};
export const postApplyJob = (data) => {
  return jobRegistration({
    url: `/jd/public-job/`,
    method: "post",
    data,
  });
};
export const patchApplyJob = (data) => {
  return jobRegistration({
    url: `/jd/public-job/`,
    method: "put",
    data,
  });
};

export const getAllThirdParties = (params) => {
  return request({
    url: `/common/third-party/`,
    method: "get",
    params,
  });
};

export const enableDisableThirdParty = (data) => {
  return request({
    url: `/common/third-party/`,
    method: "put",
    data,
  });
};

export const getAuthRegisterJob = (data) => {
  return jobAuthRegistration({
    url: `/jd/public-job/?jobID=${data}`,
    method: "get",
  });
};

export const getUserInfo = (data) => {
  return ServiceAuthCandidate({
    url: `user/public-profile/?username=${data}&loggedIn=false&public=true`,
    method: "get",
  });
};
export const addSlotCandidate = (data) => {
  return jobAuthRegistration({
    url: `cus/v2/addcand/`,
    method: "post",
    data,
  });
};

export const uploadSlotdDocumentAPI = (data) => {
  return jobAuthRegistration({
    url: `/common/file-upload-patch/`,
    method: "patch",
    data,
  });
};
export const getReassignData = (data) => {
  return requestrbac({
    url: `permissionDetials/?project=recruitment&licenseKey=${data.licenseKey}&permission=GET_JOBDASHBOARD&searchQuery=${data.searchQuery}`,
    method: "get",
  });
};

export const reassignTalentpool = (data) => {
  return request({
    url: `/cus/accessibility-update/`,
    method: "put",
    data,
  });
};

export const checkJobDateSlot = (data) => {
  return jobAuthRegistration({
    url: `jd/slots-remaining-count/`,
    method: "post",
    data,
  });
};

export const sendConfExpiredNoitification = (data) => {
  return request({
    url: `/jd/config-expiry-notify/`,
    method: "post",
    data,
  });
};

export const getRMList = (params) => {
  return request({
    url: `/jd/regional-manager/`,
    method: "get",
    params,
  });
};

export const getJobApplicationStats = (data) => {
  return request({
    url: `/jd/get-job-application-stats/`,
    method: "get",
    params: data,
  });
};
export const getAiSuggestionsForFeedback = (params) => {
  return serviceUploadResume({
    url: `/ai/feedback-form/`,
    method: "get",
    params,
  });
};
export const getAiSuggestionsForInterview = (params) => {
  return request({
    url: `/int/interview-process-gen/`,
    method: "get",
    params,
  });
};

export const scheduleGmeet = (data) => {
  return request({
    url: `/common/google-meet/`,
    method: "post",
    data,
  });
};

export const reScheduleGmeet = (data) => {
  return request({
    url: `/common/google-meet/`,
    method: "put",
    data,
  });
};

export const removeGmeet = (data) => {
  return request({
    url: `/common/google-meet/`,
    method: "delete",
    data,
  });
};

export const rejectAppliedCandidate = (data) => {
  return request({
    url: `/pan/reject-candidate/`,
    method: "post",
    data,
  });
};

export const addNoteAndAttachment = (data) => {
  return request({
    url: `/common/notes/`,
    method: "post",
    data,
  });
};

export const getNotes = (data) => {
  return request({
    url: `/common/notes/`,
    method: "get",
    params: data,
  });
};

export const getActivePanelist = (data) => {
  return request({
    url: "/pan/v2/active-panel-list/",
    method: "post",
    data,
  });
};
export const getNoteAndAttachment = (data) => {
  return request({
    url: `/common/notes/?candidateID=${data}`,
    method: "get",
  });
};

export const candIsOnBoarded = (data) => {
  return request({
    url: "/pan/update-status/",
    method: "put",
    data,
  });
};

export const getReassignRec = (data) => {
  return request({
    url: "/cus/v2/reassign-candidates/",
    method: "put",
    data,
  });
};

export const addJobOppurtunity = (data) => {
  return request({
    url: "/common/interest-check/",
    method: "post",
    data,
  });
};

export const changePositionID = (data) => {
  return request({
    url: "/jd/assign-position-id/",
    method: "put",
    data,
  });
};

export const getMyPositionID = (params) => {
  return request({
    url: "/jd/my-positions/",
    method: "get",
    params,
  });
};

export const getCandidateDetails = (data) => {
  return request({
    url: "/cus/candidate-detail/",
    method: "post",
    data,
  });
};
// get cvs candidate data
export const getCVSDocuments = (data) => {
  return request({
    url: `/bgv/cvs/`,
    method: "get",
    params: {
      candidateID: data.candidateID,
    },
  });
};

export const trigerCvs = (data) => {
  return request({
    url: `/bgv/cvs/`,
    method: "post",
    data,
  });
};

export const deleteRecruiter = (data) => {
  return request({
    url: `/jd/delete-recruiter/`,
    method: "put",
    data,
  });
};

export const getDeleteRecruiterData = (data) => {
  return request({
    url: `/jd/delete-recruiter/`,
    method: "get",
    params: data,
  });
};

export const reAnalyzeResume = (data) => {
  return request({
    url: `/jd/re-analyze/`,
    method: "post",
    data,
  });
};

export const triggerResumeReport = (data) => {
  return request({
    url: `/common/resume-report-trigger/`,
    method: "post",
    data,
  });
};

export const getResumeReport = (data) => {
  return request({
    url: `/common/resume-report/?candidateID=${data.candidateID}&customerID=${data.customerID}&jobID=${data.jobID}`,
    method: "get",
  });
};

export const exportKanbanCands = (data) => {
  return request({
    url: `/jd/job-candidate-information/`,
    method: "post",
    responseType: "blob",
    data,
  });
};

export const getCandRanking = (data) => {
  return request({
    url: `/jd/rank-selected-candidate/`,
    method: "post",
    data,
  });
};

export const getCandidateCount = (data) => {
  return request({
    url: `/jd/recruiter-positions/`,
    method: "get",
    params: data,
  });
};

export const deletePositionID = (data) => {
  return request({
    url: `/jd/recruiter-positions/`,
    method: "put",
    data,
  });
};
export const resumeParser = (data) => {
  return serviceUploadResume({
    url: `/ai/add-candidate-parser/`,
    method: "post",
    data,
  });
};

export const jdParser = (data) => {
  return serviceUploadResume({
    url: `/ai/add-jd-parser/`,
    method: "post",
    data,
  });
};

export const getCreditsInfo = () => {
  return request({
    url: `/jd/credits-info/`,
    method: "get",
  });
};

export const moveToFirst = (data) => {
  return request({
    url: `/pan/move-candidate/`,
    method: "post",
    data,
  });
};

export const sendForScreening = (data) => {
  return request({
    url: `/common/screening/`,
    method: "post",
    data,
  });
};

export const sendLinkInEmail = (data) => {
  return request({
    url: `/common/interest-check/`,
    method: "post",
    data,
  });
};

export const getCandScreeningData = (params) => {
  return request({
    url: `/common/screening/`,
    method: "get",
    params,
  });
};

// HR DOCUMENTS APIS

export const getDocumentsTable = (params) => {
  return request({
    url: `/hro/upload-documents/`,
    method: "get",
    params,
  });
};

export const postDocuments = (data) => {
  return request({
    url: `/hro/upload-documents/`,
    method: "post",
    data,
  });
};

export const editDocuments = (data) => {
  return request({
    url: `/hro/upload-documents/`,
    method: "put",
    data,
  });
};

export const deleteDocuments = (data) => {
  return request({
    url: `/hro/upload-documents/`,
    method: "delete",
    data,
  });
};

export const uploadTemplates = (data) => {
  return request({
    url: `/hro/upload-template-files/`,
    method: "put",
    data,
  });
};

export const requestForDocs = (data) => {
  return request({
    url: `/hro/kanban-documents/`,
    method: "post",
    data,
  });
};

export const getKanbanDocs = (params) => {
  return request({
    url: `/hro/kanban-documents/`,
    method: "get",
    params,
  });
};

export const acptRjctKanbanDocs = (data) => {
  return request({
    url: `/hro/kanban-documents/`,
    method: "put",
    data,
  });
};

export const getCandOnboardingDocs = (params) => {
  return request({
    url: `/hro/doc-status/`,
    method: "get",
    params,
  });
};

export const checkInterviews = (data) => {
  return request({
    url: `/jd/interviews-check/`,
    method: "get",
    params: data,
  });
};

export const tempResume = (data) => {
  return request({
    url: `/common/temp-resume/`,
    method: "post",
    data,
  });
};

export const raiseReport = (data) => {
  return ServiceCandidate({
    url: "user/raise-ticket/",
    method: "post",
    data,
  });
};

export const getTicketHistory = () => {
  return ServiceCandidate({
    method: "get",
    url: "user/candidate-ticket-history/",
  });
};

export const getBotAnalysis = (params) => {
  return request({
    url: `/common/bot-interview-analysis/${params}`,
    method: "get",
  });
};

export const getAssessmentMarks = (params) => {
  return ServiceCandidate({
    url: `/can/view-marks/`,
    method: "get",
    params,
  });
};

export const getPassFailCands = (params) => {
  return request({
    url: `/jd/candidate-assessment-status/`,
    method: "get",
    params: params,
  });
};

export const getHistoryHtml = (data) => {
  return request({
    url: `/jd/dossier/`,
    method: "post",
    data,
  });
};

export const getSkillSuggestion = (params) => {
  return requestSuggestion({
    url: `/suggest-skills/`,
    method: "get",
    params: params,
  });
};

export const getNotificationData = (data) => {
  return notificationAuth({
    url: `notification/?project=Recruitment&page=${data.page}&count=${data.count}&order=${data.order}`,
    method: "get",
    data,
    params: {
      userID: data.userID,
    },
  });
};

export const markasReadNotification = (data) => {
  return notificationAuth({
    url: `notification/`,
    method: "put",
    data,
  });
};

export const getProtfolioLink = (params) => {
  return request({
    url: `/jd/dossier/`,
    method: "get",
    params,
  });
};

export const markasReadandUnreadNotification = (data) => {
  return notificationAuth({
    url: `notification/`,
    method: "put",
    data,
  });
};

export const getBookmarkFolders = async (params) => {
  return requestrbac({
    url: `/get-candidate-teams`,
    method: "get",
    params,
  });
};

export const getPanelFeedbacks = (params) => {
  return request({
    url: `/jd/panel-uploaded-feedbacks/`,
    method: "get",
    params,
  });
};

export const getHire3xPanelCount = (data) => {
  return ServiceCandidate({
    url: `/pan/availabel-panel-count/`,
    method: "post",
    data,
  });
};

export const selectPanelSlot = (data) => {
  return ServiceCandidate({
    url: `/pan/recruiter-slot-select/`,
    method: "post",
    data,
  });
};

export const getSelectedPanelSlot = (params) => {
  return ServiceCandidate({
    url: `/pan/recruiter-slot-select/`,
    method: "get",
    params,
  });
};

export const removeSelectedPanelSlot = (data) => {
  return ServiceCandidate({
    url: `/pan/recruiter-slot-select/`,
    method: "delete",
    data,
  });
};

export const getTalentPoolMatches = (data) => {
  return request({
    url: `cus/v3/talent-pool/match/`,
    method: "post",
    data,
  });
};
